// Salida de sesión del backoffice, en un solo lugar.
//
// Antes esto era un callejón sin salida: cuando el token vencía, el backend empezaba a
// responder 1002 y cada pantalla mostraba el alert genérico "La sesión expiró" sin moverse
// de donde estaba. La única salida —el botón "Cerrar sesión"— sólo limpiaba y redirigía
// dentro del `else` de la respuesta del POST /session/logout, o sea justo en el caso que NO
// pasa cuando la sesión ya venció: el 1002 caía en el `if (data.error > 0) alert(...)` y no
// limpiaba nada. El usuario quedaba encerrado hasta borrar el localStorage a mano.
//
// El destino, además, salía de REACT_APP_REDIRECT_LOGIN, que en .env-local/.env-dev apunta
// a http://localhost:3000 — un puerto donde no hay nada (el backoffice corre en :3009), así
// que el redirect moría en una pestaña rota. El login es una ruta de ESTA misma app
// (Router.js: <Route exact path="/" component={LoginPage} />) en todos los entornos, así que
// se navega a '/' y deja de haber algo que configurar por entorno.

// Varias pantallas disparan fetch en paralelo y todas pueden recibir el 1002. Sin esta
// guarda cada una lanzaría su propio redirect.
let leaving = false;

// Se limpia TODO, igual que hacía el logout exitoso: además del token quedan `role`, `email`
// y el cache de sucursal, y un role huérfano hace que la próxima pantalla decida permisos
// con datos de una sesión que ya no existe.
export function clearSession() {
    try {
        localStorage.clear();
        sessionStorage.clear();
    } catch (error) {
        // Safari en modo privado puede tirar al escribir storage. Que falle la limpieza no
        // puede impedir el redirect, que es lo que saca al usuario del callejón.
    }
}

// Manda al login SIN cerrar la sesión. Para el caso de "esta pantalla no es para tu rol":
// el usuario está logueado de verdad y borrarle la sesión sería sacarlo por la fuerza.
export function goToLogin() {
    if (leaving) {
        return;
    }
    leaving = true;
    // replace y no href: la pantalla a la que no se puede entrar no debe volver con Atrás.
    window.location.replace('/');
}

// Cierra la sesión y manda al login. Para sesión vencida/inválida y para el logout explícito.
export function endSession() {
    if (leaving) {
        return;
    }
    clearSession();
    goToLogin();
}
